import React from 'react';
import { Link } from 'react-router-dom';
import founderVideo from '../../../assets/site/founder-message.mp4';
import founderPoster from '../../../assets/site/founder-message-poster.jpg';
import { founder, story } from '../../about/aboutContent';
import Section from '../../site/components/Section';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import styles from './FounderMessage.module.css';

const FounderMessage = () => (
  <Section id="founder-message" className={styles.founderMessage}>
    <div className={cx(ui.wrap, styles.grid)}>
      <div data-reveal="">
        <span className={ui.eyebrow}>Founder’s message</span>
        <h2 className={styles.title}>
          A word from <span className={ui.grad}>our founder</span>
        </h2>
        <figure className={styles.quote}>
          <blockquote>“{story.vision}”</blockquote>
          <figcaption>
            — {founder.name}, {founder.role}
          </figcaption>
        </figure>
        <Link className={cx(ui.btn, ui.btnGhost)} to="/about">
          Read our story
        </Link>
      </div>

      <div className={cx(styles.player, ui.glass)} data-reveal="">
        {/* preload="none": the 8 MB file only downloads once a visitor presses play */}
        <video
          className={styles.video}
          src={founderVideo}
          poster={founderPoster}
          controls
          playsInline
          preload="none"
          aria-label={`Founder’s message from ${founder.name}`}
        />
      </div>
    </div>
  </Section>
);

export default FounderMessage;
